import React, { memo, useLayoutEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import usePrevious from '../../../hooks/usePrevious'

const OtpCellComponent = ({ focus, autoFocus, ...props }) => {
  const inputRef = useRef(null)
  const prevFocus = usePrevious(!!focus)

  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus()
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus()
        inputRef.current.select()
      }
    }
  }, [autoFocus, focus, prevFocus])

  return <input ref={inputRef} {...props} />
}

const OtpCell = memo(OtpCellComponent)

OtpCellComponent.propTypes = {
  focus: PropTypes.bool,
  autoFocus: PropTypes.bool
}

export default OtpCell
